import { useContext } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { playEquipmentById } from '@lc/const/socketEvent';
import '@/style/HandModal.css';
import { createActionParams } from '@lc/interface/actionParams/factory';

const DiscardCardFromHandModal = ({ onClose }) => {
	const {
		// currPlayer,
		myState,

		performAction,
	}: any = useContext(GameContext);

	const performActionTyped = performAction as performActionType;

	const { recyclingCardId }: any = useContext(ViewContext);

	function chooseCardForRecycling(e, discardCardId: number) {
		e.preventDefault();

		const actionParams = createActionParams(recyclingCardId);
		actionParams.discardCardId = discardCardId;

		performActionTyped(playEquipmentById, actionParams);
		onClose();
	}

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2 className="modal-title">Choose Card to Discard</h2>
				<div className="hand">
					{myState?.seasonalCards.length > 0 &&
						myState?.seasonalCards.map((cardId) => (
							<div className="card">
								<SeasonalCard
									cardId={cardId}
									width={0}
									height={0}
								/>
								<button
									value={0}
									onClick={(e) =>
										chooseCardForRecycling(e, cardId)
									}
								>
									Select
								</button>
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

export default DiscardCardFromHandModal;
